import { createRouter, createWebHistory } from "vue-router";

// Import your views
import HomeView from "@/views/HomeView.vue";
import DashboardView from "@/views/DashboardView.vue";
import UploadView from "@/views/UploadView.vue";
import DownloadView from "@/views/DownloadView.vue";
import ListView from "@/views/ListView.vue";
import LoginView from "@/views/LoginView.vue";
import SignupView from "@/views/SignupView.vue";
import ForgotPasswordView from "@/views/ForgotPasswordView.vue";
import SettingView from "@/views/SettingView.vue";

const routes = [
  // { path: '/', name: 'Home', component: HomeView },

  {
    path: "/",
    name: "Home",
    component: HomeView,
    meta: { backgroundClass: "home-background" },
  },

  {
    path: "/login",
    name: "Login",
    component: LoginView,
    meta: { backgroundClass: "login-background" },
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardView,
    meta: { backgroundClass: "default-background" },
  },
  {
    path: "/upload",
    name: "Upload",
    component: UploadView,
    meta: { backgroundClass: "default-background" },
  },
  {
    path: "/download",
    name: "Download",
    component: DownloadView,
    meta: { backgroundClass: "default-background" },
  },
  {
    path: "/list",
    name: "List",
    component: ListView,
    meta: { backgroundClass: "default-background" },
  },
  //{ path: '/login', name: 'Login', component: LoginView },
  {
    path: "/signup",
    name: "Signup",
    component: SignupView,
    meta: { backgroundClass: "default-background" },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPasswordView,
    meta: { backgroundClass: "default-background" },
  },
  {
    path: "/setting",
    name: "SettingView",
    component: SettingView,
    meta: { backgroundClass: "default-background" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
